import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IAnimalCategory } from "../../../../../../@types/app/AnimalCategory/ICategory";
import { IAnimalMonth } from "../../../../../../@types/app/AnimalCategory/IMonths";
import "./styles.css";
import { translateAnimalCategory, translateAnimalCategoryAge } from "../../../../../../i18n/translateAnimalCategory";

type TableVisualizationRow = {
  category: IAnimalCategory;
  month: IAnimalMonth;
};

export function TableVisualizationRow({
  category: defaultcategory,
  month: defaultMonth,
}: TableVisualizationRow) {
  useTranslation();
  const [category, setCategory] = useState<IAnimalCategory>(defaultcategory);
  const [{ weight }, setMonthProps] = useState<IAnimalMonth>(defaultMonth);

  useEffect(() => {
    setCategory(() => defaultcategory);
    setMonthProps(() => defaultMonth);
  }, [defaultcategory, defaultMonth]);

  return (
    <div className="containerTable__content--item">
      <div>{translateAnimalCategory(category.name, category.age_description)}</div>
      <div>{translateAnimalCategoryAge(category.age_description, category.name)}</div>
      <div>
        {weight.value} {weight.unit}
      </div>
    </div>
  );
}
